<div class="card">
  <p-toolbar>
    <ng-template #start>
      <p-button (onClick)="onToggleSidebar()" class="mr-2" icon="pi pi-bars" severity="secondary" text/>
      <img alt="" class="logo-header" src="assets/img/logo_cristalia_short.png">
    </ng-template>

    <ng-template #end>
      <app-unit-company-selection></app-unit-company-selection>
      <p-button (onClick)="logout()" icon="pi pi-power-off" label="Sair  " severity="info"></p-button>
    </ng-template>
  </p-toolbar>
</div>
